// Shown once per page load (below the navbar) when the user has an unread
// "storage_expiring" notification — the daily warning Karvi's backend sends
// during the 15-day grace period after a Studio storage plan lapses.
// Dismissing marks the underlying notification read (same effect as reading
// it from the bell), so it won't reappear until tomorrow's fresh warning.
import { useEffect, useState } from "react";
import { notifications as notifApi } from "../api";

export default function StorageExpiryBanner({ user }) {
  const [notif, setNotif] = useState(null);

  useEffect(() => {
    if (!user) return setNotif(null);
    let alive = true;
    notifApi
      .list()
      .then((d) => {
        if (!alive) return;
        const match = (d.notifications || []).find((n) => n.type === "storage_expiring" && !n.read);
        setNotif(match || null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [user]);

  if (!notif) return null;

  const dismiss = () => {
    notifApi.markRead(notif.id).catch(() => {});
    setNotif(null);
  };

  return (
    <div className="storage-banner" role="alert">
      <span className="storage-banner__icon" aria-hidden>⚠️</span>
      <span className="storage-banner__msg">{notif.message}</span>
      <button className="storage-banner__dismiss" onClick={dismiss} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
